// extracted by mini-css-extract-plugin
module.exports = {"label-color":"_TitleField_label-color_f7YKT","select":"_TitleField_select_195oh"};